import {
	IForgetPasswordSms,
	IRegisterUser,
	IVerifyPassword,
	ILoginUser,
	IUpdateProfile,
	IRequestLocationReport,
	ICheckLocationReport,
	IUpdatePassword,
	IUpdateServices,
	IStoreService,
	ICreateGeoArea,
	IStoreCommand,
	IDeleteService,
} from "../../types/typeFetching";
import {
	authForgetPasswordUrl,
	authVerifyPasswordUrl,
	authLoginUrl,
	authRegisterUrl,
	indexUserTrackersUrl,
	indexAllServicesUrl,
	indexTransactionsUrl,
	getProfileInfoUrl,
	updateProfileInfoUrl,
	requestLocationReportUrl,
	checkLocationReportUrl,
	trackerNotificationsUrl,
	getAllGeoAreaUrl,
	createGeoAreaUrl,
	deleteGeoAreaUrl,
	updateGeoAreaUrl,
	authResetPasswordUrl,
	sessionUrl,
	getGeoAreaUrl,
	sessionDeleteUrl,
	authCheck,
	baseUrl,
} from "../config/urls";
import { axiosInterCeptors } from "../config/axiosInteceptors";

//Auth
export const authRegister = async (data: IRegisterUser) => {
	const result = await axiosInterCeptors.post(`${authRegisterUrl}`, data);
	return result;
};
export const authCheckUser = async (id: any) => {
	const result = await axiosInterCeptors.post(`${authCheck}`, {
		session_id: id,
	});
	return result;
};
export const sessionListAuth = async () => {
	const result = await axiosInterCeptors.get(`${sessionUrl}`);
	return result;
};
export const sessionDelete = async (id: any) => {
	const result = await axiosInterCeptors.post(`${sessionDeleteUrl}`, {
		session_id: id,
	});
	return result;
};

export const authForgetPassword = async (data: IForgetPasswordSms) => {
	const result = await axiosInterCeptors.post(`${authForgetPasswordUrl}`, data);
	return result;
};

export const authresetPassword = async (data: IVerifyPassword) => {
	const result = await axiosInterCeptors.post(`${authResetPasswordUrl}`, data);
	return result;
};
export const authVerifyPassword = async (data: IVerifyPassword) => {
	const result = await axiosInterCeptors.post(`${authVerifyPasswordUrl}`, data);
	return result;
};
export const authLogin = async (data: ILoginUser) => {
	const result = await axiosInterCeptors.post(`${authLoginUrl}`, data);
	return result;
};

//App
export const indexUserTrackers = async () => {
	const result = await axiosInterCeptors.get(`${indexUserTrackersUrl}`);
	return result;
};
export const deleteTracker = async (id: any) => {
	const result = await axiosInterCeptors.delete(
		`${indexUserTrackersUrl}/${id}`
	);
	return result;
};
export const indexUseagesTrackers = async () => {
	const result = await axiosInterCeptors.get(`${indexUserTrackersUrl}/usages`);
	return result;
};
export const indexAllServices = async () => {
	const result = await axiosInterCeptors.get(`${indexAllServicesUrl}`);
	return result;
};
export const indexAllServicesGroup = async () => {
	const result = await axiosInterCeptors.get(`${indexAllServicesUrl}/groups`);
	return result;
};
export const newServicesGroup = async (data: IStoreService) => {
	const result = await axiosInterCeptors.post(
		`${indexUserTrackersUrl}/${data.trackerId}/services`,
		{
			title: data.title,
			started_at: data.started_at,
			group_id: data.group_id,
			duration: data.duration,
		}
	);
	return result;
};
export const delServicesGroup = async (data: IDeleteService) => {
	const result = await axiosInterCeptors.delete(
		`${indexUserTrackersUrl}/${data.trackerId}/services/${data.serviceId}`,
		{
			params: {
				title: data.title,
				duration: data.duration,
			},
		}
	);
	return result;
};

export const indexTransactionsService = async () => {
	const result = await axiosInterCeptors.get(
		`${indexTransactionsUrl}?token=${localStorage.token}`
	);

	return result;
};

export const getProfileInfo = async () => {
	const result = await axiosInterCeptors.get(`${getProfileInfoUrl}`);
	return result;
};
export const storeNewTracker = async (data: any) => {
	const result = await axiosInterCeptors.post(`${indexUserTrackersUrl}`, data);
	return result;
};
export const updateTracker = async (data: any) => {
	const result = await axiosInterCeptors.put(
		`${indexUserTrackersUrl}/${data.id}`,
		{
			title: data.title,
			driver_name: data.driver_name,
			sim_number: data.sim_number,
			usage_id: data.usage_id,
			fuel_usage: data.fuel_usage,
		}
	);
	return result;
};
export const getImeiTracker = async (imei: string | undefined) => {
	const result = await axiosInterCeptors.get(
		`${indexUserTrackersUrl}/imei/${imei}`
	);
	return result;
};
export const updatePassword = async (data: IUpdatePassword) => {
	const result = await axiosInterCeptors.post(
		`${getProfileInfoUrl}/password`,
		data
	);
	return result;
};
export const updateProfileInfo = async (data: IUpdateProfile) => {
	const result = await axiosInterCeptors.put(`${updateProfileInfoUrl}`, data);
	return result;
};
export const updateProfilePhoto = async (data: any) => {
	const result = await axiosInterCeptors.put(
		`${updateProfileInfoUrl}/photo`,
		data
	);
	return result;
};
export const updateServices = async (data: IUpdateServices) => {
	const result = await axiosInterCeptors.put(
		`${indexUserTrackersUrl}/${data.trackerId}/services/${data.serviceId}`,
		{
			title: data.title,
			duration: data.duration,
		}
	);
	return result;
};

export const getLocationReport = async (data: IRequestLocationReport) => {
	const result = await axiosInterCeptors.get(
		`${requestLocationReportUrl}?id=${data.id}&start_date=${data.startDate}&end_date=${data.endDate}`
	);
	return result;
};

export const checkLocationReport = async (data: ICheckLocationReport) => {
	const result = await axiosInterCeptors.get(
		`${checkLocationReportUrl}/${data.token}`
	);
	return result;
};

export const getTrackerNotifications = async (id: string | undefined) => {
	const result = await axiosInterCeptors.get(
		`${trackerNotificationsUrl}?type=1&tracer_id=${id}`
	);
	return result;
};

export const getAllGeoArea = async () => {
	const result = await axiosInterCeptors.get(`${getAllGeoAreaUrl}`);
	return result;
};

export const getGeoArea = async ({ queryKey }: any) => {
	const [_, data] = queryKey;

	const result = await axiosInterCeptors.get(
		`${getGeoAreaUrl}/${data.trackerId}/geo-areas/${data.geoId}`
	);
	return result;
};

export const storeCommandTracker = async (data: IStoreCommand) => {
	const result = await axiosInterCeptors.post(
		`${indexUserTrackersUrl}/${data.id}/commands/custom/send`,
		{
			command: data.command,
		}
	);
	return result;
};

export const createGeoArea = async (data: ICreateGeoArea) => {
	const result = await axiosInterCeptors.post(
		`${createGeoAreaUrl}/${data.id}/geo-areas`,
		{ send_sms: data.send_sms, name: data.name, coordinates: data.coordinates }
	);
	return result;
};

export const deleteGeoArea = async (data: {
	trackerId: string;
	geoId: string;
}) => {
	const result = await axiosInterCeptors.delete(
		`${deleteGeoAreaUrl}/${data.trackerId}/geo-areas/${data.geoId}`
	);
	return result;
};
export const checkCommand = async (id: any, token: string) => {
	const result = await axiosInterCeptors.get(
		`${baseUrl}/clients/tracers/${id}/commands/check/${token}`
	);
	return result;
};

export const updateGeoArea = async (data: {
	trackerId: any;
	geoId: any;
	send_sms: number;
	name: string;
	coordinates: any;
}) => {
	const result = await axiosInterCeptors.put(
		`${updateGeoAreaUrl}/${data.trackerId}/geo-areas/${data.geoId}`,
		{
			send_sms: data.send_sms,
			name: data.name,
			coordinates: data.coordinates,
		}
	);
	return result;
};
export const subNotification = async (data: any) => {
	const result = await axiosInterCeptors.post(
		`${baseUrl}/clients/notifications/subscribe`,
		{
			key: data,
		}
	);
	return result;
};
export const deleteFcmNotification = async (token: any) => {
	const result = await axiosInterCeptors.delete(
		`${baseUrl}/clients/notifications/subscribe/${token}`
	);
	return result;
};
